export const openChatWidgetComponent = {
  key: 'openChatWidgetComponent',
  name: 'Open Chat Widget Component',
  siteIdentifier: 'global',

  startChatButton: 'Start a Chat',
  liveChatButton: 'Live Chat',
  chatWithAgentNowButton: 'Chat with an Agent Now',
};
